module.exports = __webpack_public_path__ + "img/6_132.5e69f2bc.png";